import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './styles.css';

const antIcon = <LoadingOutlined type="loading" style={{ fontSize: 100 }} spin />;

const LoadingPage = () => {
    return (
        <div className="SpinCont">
            <Spin size="large" indicator={antIcon} style={{ fontSize: 20 }} />
        </div>
    );
};

LoadingPage.propTypes = {
    
};

export default LoadingPage;